export const DEFAULT_ERROR_MSG = '服务器开小差，请稍后再试'